import type { ServerBillingStatus, ServerMembership } from '@oracord/shared';

type Role = ServerMembership['role'];

export function billingAllowsAppAccess(billing: ServerBillingStatus | null): boolean {
  return Boolean(billing?.active);
}

export function isBillingRoute(pathname: string): boolean {
  return pathname === '/billing' || pathname.startsWith('/billing/');
}

export function shouldRedirectToBilling({
  pathname,
  search = '',
  role,
  billing,
}: {
  pathname: string;
  search?: string;
  role: Role;
  billing: ServerBillingStatus | null;
}): boolean {
  void pathname;
  void search;
  void role;
  void billing;
  return false;
}

export function shouldWaitForActiveOrganizationRepair({
  activeOrgId,
  resolvedOrgId,
}: {
  activeOrgId: string | null;
  resolvedOrgId: string;
}): boolean {
  return activeOrgId !== resolvedOrgId;
}

export function defaultSignedInHomePath({
  role,
  billing,
  hasConnectedSource,
}: {
  role: Role;
  billing: ServerBillingStatus | null;
  hasConnectedSource: boolean;
}): '/billing' | '/setup' | '/staff/setup' {
  if (role === 'member') return '/staff/setup';
  void billing;
  void hasConnectedSource;
  return '/setup';
}
